import React, { useContext, useEffect, useState } from "react";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
  VALIDATOR_EMIAL,
  VALIDATOR_NUMBER_ONLY,
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
} from "../../shared/util/validators";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { baseUrl } from "../../baseUrl";
import { AuthContext } from "../../context/AuthContext";
import { ReplayCircleFilled } from "@mui/icons-material";

const EditUser = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const data = props.data;
  // Extract the cityId and cityName
  const { cityId, cityName, provinceId, provinceName } = data.location;
  const prevCity = { cityId, cityName };
  const prevProvince = { provinceId, provinceName };

  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);

  const [formState, inputHandler, setFormData] = useForm(
    {
      labName: {
        value: auth.name,
        isValid: true,
      },
      name: {
        value: data.name,
        isValid: true,
      },
      lastName: {
        value: data.lastName,
        isValid: true,
      },
      address: {
        value: data.address,
        isValid: true,
      },
      email: {
        value: data.email,
        isValid: true,
      },
      username: {
        value: data.username,
        isValid: true,
      },
      number: {
        value: data.number,
        isValid: true,
      },
      phoneNumber: {
        value: data.phoneNumber,
        isValid: true,
      },
      lastName: {
        value: data.lastName,
        isValid: true,
      },
      province: {
        value: prevProvince,
        isValid: true,
      },
      city: {
        value: prevCity,
        isValid: true,
      },
    },
    false
  );

  useEffect(() => {
    setFormData(
      {
        labName: {
          value: auth.name,
          isValid: true,
        },
        name: {
          value: data.name,
          isValid: true,
        },
        lastName: {
          value: data.lastName,
          isValid: true,
        },
        address: {
          value: data.address,
          isValid: true,
        },
        email: {
          value: data.email,
          isValid: true,
        },
        username: {
          value: data.username,
          isValid: true,
        },
        number: {
          value: data.number,
          isValid: true,
        },
        phoneNumber: {
          value: data.phoneNumber,
          isValid: true,
        },
        province: {
          value: prevProvince,
          isValid: true,
        },
        city: {
          value: prevCity,
          isValid: true,
        },
      },
      true
    );
    setIsLoading(false);
  }, [setFormData, props.open]);

  //getting provinces
  useEffect(() => {
    const getProvinces = async () => {
      try {
        const response = await fetch(
          baseUrl + "/api/v1/locations/get-locations-province",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setProvinces(responseData);
      } catch (err) {
        setIsLoading(false);
        const messages = err.data.length > 0 ? err.data : err.message.message;
        messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        });
        setIsLoading(false);
      }
    };
    getProvinces();
  }, []);

  //   getting cities
  useEffect(() => {
    const getCities = async () => {
      if (formState.inputs.province.value !== undefined) {
        setIsLoading(true);
        try {
          const response = await fetch(
            baseUrl + "/api/v1/locations/get-locations-city",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                provinceId: formState.inputs.province.value.provinceId,
              }),
            }
          );
          const responseData = await response.json();
          setCities(responseData);
          setIsLoading(false);
        } catch (err) {
          setIsLoading(false);
          const messages = err.data.length > 0 ? err.data : err.message.message;
          messages.map((message) => {
            enqueueSnackbar(message, { variant: "error" });
          });
          setIsLoading(false);
        }
      }
    };
    getCities();
  }, [formState.inputs.province.value]);

  //test
  //   useEffect(() => {
  //     console.log(formState.inputs);
  //   }, [formState.inputs]);
  //   console.log(data);

  const updateHandler = async (event) => {
    setIsLoading(true);
    try {
      const response = await fetch(baseUrl + "/api/v1/users/update-profile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: auth.token,
        },
        body: JSON.stringify({
          companyName: formState.inputs.labName.value,
          name: formState.inputs.name.value,
          lastName: formState.inputs.lastName.value,
          address: formState.inputs.address.value,
          locationId: formState.inputs.city.value.id,
          number: formState.inputs.number.value,
          phoneNumber: formState.inputs.phoneNumber.value,
          email: formState.inputs.email.value,
          type: data.type,
          username: formState.inputs.username.value,
        }),
      });
      const responseData = await response.json();
      console.log(responseData.message.message);
      if (!response.ok) {
        throw new Error(responseData.message);
      } else {
        enqueueSnackbar(responseData.message.message, {
          variant: "success",
        });
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      err && enqueueSnackbar(err.message, { variant: "error" });
    }
    props.close();
  };

  // handling isLoading
  if (isLoading) {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }

  return (
    <React.Fragment>
      <form onSubmit={updateHandler}>
        <Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2, m: 1 }} elevation={2}>
          <Grid container spacing={1}>
            <Grid md={6} xs={12}>
              <Input
                id="labName"
                element="input"
                label="نام لابراتوار"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا نام لابراتوار را وارد کنید"
                initialValue={formState.inputs.labName.value}
                inputValid={formState.inputs.labName.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="username"
                element="input"
                label="نام کاربری"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا نام کاربری را وارد کنید"
                initialValue={formState.inputs.username.value}
                inputValid={formState.inputs.username.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="name"
                element="input"
                label="نام"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا نام را وارد کنید"
                initialValue={formState.inputs.name.value}
                inputValid={formState.inputs.name.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="lastName"
                element="input"
                label="نام خانوادگی"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا  نام خانوادگی را وارد کنید"
                initialValue={formState.inputs.lastName.value}
                inputValid={formState.inputs.lastName.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="email"
                element="input"
                label="ایمیل"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا ایمیل را وارد کنید"
                initialValue={formState.inputs.email.value}
                inputValid={formState.inputs.email.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="address"
                element="input"
                label="آدرس"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا آدرس را وارد کنید"
                initialValue={formState.inputs.address.value}
                inputValid={formState.inputs.address.isValid}
                onInput={inputHandler}
              />
            </Grid>

            <Grid md={6} xs={12}>
              <Input
                id="province"
                element="autoComplete"
                label="استان"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا استان را انتخاب کنید."
                initialValue={formState.inputs.province.value}
                inputValid={formState.inputs.province.isValid}
                onInput={inputHandler}
                options={provinces}
                getOptionLabel={(option) => option.provinceName}
                required={true}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="city"
                element="autoComplete"
                label="شهر"
                validators={[VALIDATOR_AUTOCOMPLETE()]}
                errorText="لطفا شهر را انتخاب کنید."
                initialValue={formState.inputs.city.value}
                inputValid={formState.inputs.city.isValid}
                onInput={inputHandler}
                options={cities}
                required={true}
                getOptionLabel={(option) => option.cityName}
              />
            </Grid>

            <Grid md={6} xs={12}>
              <Input
                id="number"
                element="input"
                label="شماره تلفن"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا شماره تلفن را وارد کنید"
                initialValue={formState.inputs.number.value}
                inputValid={formState.inputs.number.isValid}
                onInput={inputHandler}
              />
            </Grid>
            <Grid md={6} xs={12}>
              <Input
                id="phoneNumber"
                element="input"
                label="شماره همراه"
                validators={[VALIDATOR_REQUIRE()]}
                errorText="لطفا شماره همراه را وارد کنید"
                initialValue={formState.inputs.phoneNumber.value}
                inputValid={formState.inputs.phoneNumber.isValid}
                onInput={inputHandler}
              />
            </Grid>

            <Grid xs={12} md={6}>
              <Button
                disabled={!formState.isValid}
                type="submit"
                fullWidth
                color="secondary"
                variant="contained"
              >
                <EditIcon />
              </Button>
            </Grid>
            <Grid xs={12} md={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={props.close}
              >
                <ArrowBackIcon />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </React.Fragment>
  );
};

export default EditUser;
